const config = {
	appDomain: 'https://client.kellypartners.com',
	apiDomain: 'https://api.kellypartners.com/',
	blobStorageRootUrl: 'https://appassets.kellypartners.com/',
	iPracticeRootUrl: 'https://login.ipracticehub.com/',
	sentryDsn: 'https://3ba9d262e2994e65a83770bec6127547@o4504574864195584.ingest.sentry.io/4504574874550272',
	environment: 'production',
	title: 'Production',
	currentCulture: 'en-AU',
	stripePublishableKey:
		'pk_live_51NLK97ItboXz9npVFxgIj7ng9gl0vEwvyud5yWUd4wpRt0GygCZqHJShP9YOmKUfgt6DDYD7eicF6WYtq75Oai4m00OZI2Le9l',
	appName: 'Kelly+Partners Passport',
	appVersion: '2.7.0',
	autoLogoutTimeoutInMs: 1800000,
	streamApiKey: '7jtgrhdd6ukg'
};

export type Config = typeof config;

export default config;
